

/// <reference path="MemoLog.ts" />

// Generated class BusinessLog_ManagedObject

class BusinessLog_ManagedObject extends MemoLog
{
    // Relationship: business
    set business(value:BusinessLicense) {
        this.setValueForKey(value, 'business');
    }
    get business():BusinessLicense {
        return this.valueForKey('business') as BusinessLicense;
    }
    // Relationship: client
    set client(value:Client) {
        this.setValueForKey(value, 'client');
    }
    get client():Client {
        return this.valueForKey('client') as Client;
    }
    // Relationship: type
    set type(value:BusinessReasonType) {
        this.setValueForKey(value, 'type');
    }
    get type():BusinessReasonType {
        return this.valueForKey('type') as BusinessReasonType;
    }
}
